import { OrderMembershipPriceApiModel } from '../order-membership-price.api.model';

export class GadgetItemApiModel {
  id: string;
  itemId: string;
  name: string;
  quantity: number;
  taxRate: number;
  price: number;
  value: number;
  defaultPriceLevelPrice: number;
  itemEarnedPoints: number;
  itemRedemptionPoints: number;
  voucherNumber: string;
  voucherName: string;
  promotionId: string;
  promotionName: string;
  discountName: string;
  noDiscountPrice: number;
  discountValue: number;
  graphics: string[];
  membershipPrices: OrderMembershipPriceApiModel[];
}
